import Details from './details';
import Invoices from './invoices';

function SubscriptionView() {
  return (
    <>
      <Details/>
      <Invoices/>
    </>
  );
}

export default SubscriptionView;
